import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function useRepositoryData() {
  const [data, setData] = useState({
    entries: [],
    characters: [],
    recaps: [],
    keepsakes: [],
    loading: true,
  });

  const fetchData = useCallback(async () => {
    try {
      const [entriesRes, charsRes, recapsRes, keepsakesRes] = await Promise.all([
        supabase.from('entries').select('*').order('created_at', { ascending: false }),
        supabase.from('characters').select('*').order('created_at', { ascending: false }),
        supabase.from('recap').select('*').order('session_number', { ascending: false }),
        supabase.from('keepsakes').select('*').order('created_at', { ascending: true }),
      ]);

      setData({
        entries: entriesRes.data || [],
        characters: charsRes.data || [],
        recaps: recapsRes.data || [],
        keepsakes: keepsakesRes.data || [],
        loading: false,
      });
    } catch (error) {
      console.error('Error fetching data:', error);
      setData(prev => ({ ...prev, loading: false }));
    }
  }, []);

  useEffect(() => {
    fetchData();

    const handleChange = () => fetchData();

    const subs = [
      supabase
        .channel('entries-ch')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'entries' }, handleChange)
        .subscribe(),
      supabase
        .channel('chars-ch')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'characters' }, handleChange)
        .subscribe(),
      supabase
        .channel('recap-ch')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'recap' }, handleChange)
        .subscribe(),
      supabase
        .channel('keepsakes-ch')
        .on('postgres_changes', { event: '*', schema: 'public', table: 'keepsakes' }, handleChange)
        .subscribe(),
    ];

    return () => {
      subs.forEach(sub => supabase.removeChannel(sub));
    };
  }, [fetchData]);

  return { ...data, refresh: fetchData };
}